import {
  useCallback, useEffect, useRef, useState,
} from 'react';
import usePluginHandler from '../../../hooks/usePluginHandler';
import { PluginMessageTypes } from '../../../models/constants';
import Log from '../../../utils/log';
import MessagesPlugin from '../../../models/messages';

/**
 * Gestisce il loading process di un IFrame.
 */
export default function useIFrameLoader(url, extraParams, checkLoaded, onSuccess, onFail) {
  const timeoutRef = useRef();
  const childLoadedRef = useRef(false);
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);

  useEffect(() => () => {
    timeoutRef.current && clearTimeout(timeoutRef.current);
  }, []);

  const messageHandler = useCallback(({ type }) => {
    if (type === PluginMessageTypes.LOADED) {
      childLoadedRef.current = true;
      setLoading(false);
    }
  }, []);
  usePluginHandler(messageHandler);

  const sendExtraData = useCallback(() => {
    if (!extraParams) return;
    MessagesPlugin.postMessageToChilds(
      PluginMessageTypes.EXTRA_PARAMS, extraParams,
    );
  }, [extraParams]);

  const onLoad = useCallback(() => {
    Log.debug(`Loading... ${url}`);
    if (!checkLoaded) {
      setLoading(false);
      return;
    }
    // verifico che l'applicativo sia stato effettivamente caricato
    let timeout = 50; // max timeout per attesa conferma caricamento
    const checkLoadOk = () => {
      Log.debug('load checking', timeout);
      if (childLoadedRef.current) {
        Log.debug('LOADED');
        sendExtraData();
        onSuccess();
      } else if ((timeout -= 10) < 0) {
        Log.debug('NOT LOADED');
        setLoadingError(true);
        onFail();
      } else {
        timeoutRef.current = setTimeout(checkLoadOk, 10);
      }
    };
    timeoutRef.current = setTimeout(checkLoadOk, 10);
  }, [checkLoaded, onFail, onSuccess, sendExtraData, url]);

  return {
    loaded: childLoadedRef.current, onLoad, loading, loadingError,
  };
}
